import { useConsolePaceUnit } from "../../hooks/useConsolePaceUnit";

/**
 * Segmented control: display pace pills in min/mi (API labels) or equivalent min/km.
 */
export default function PaceUnitToggle({ className = "" }) {
  const { unit, setUnit } = useConsolePaceUnit();
  const base =
    "px-2.5 py-1 text-xs font-medium rounded transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--console-accent)] focus-visible:ring-offset-1";
  return (
    <div
      className={`inline-flex rounded-md border border-[var(--console-border)] p-0.5 bg-[var(--console-s2)] ${className}`}
      role="group"
      aria-label="Pace unit"
    >
      <button
        type="button"
        onClick={() => setUnit("mi")}
        className={`${base} ${
          unit === "mi"
            ? "bg-[var(--console-surface)] text-[var(--console-ink)] shadow-sm"
            : "text-[var(--console-muted)] hover:text-[var(--console-ink)]"
        }`}
      >
        / mi
      </button>
      <button
        type="button"
        onClick={() => setUnit("km")}
        className={`${base} ${
          unit === "km"
            ? "bg-[var(--console-surface)] text-[var(--console-ink)] shadow-sm"
            : "text-[var(--console-muted)] hover:text-[var(--console-ink)]"
        }`}
      >
        / km
      </button>
    </div>
  );
}
